module.exports = __webpack_public_path__ + "img/fashion_49.a675eefc.jpg";